import script from "./CalendarBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarBlock.vue?vue&type=script&setup=true&lang=js"

import "./CalendarBlock.vue?vue&type=style&index=0&id=3f0b8bd7&lang=scss"

const __exports__ = script;

export default __exports__